export default __webpack_public_path__ + "static/media/payment_fail.1bd94cc1.png";